import TopCampanies from 'admin/components/dashboardcom/TopCampanies';
import CompaniesCom from 'admin/components/jobhistory/companies/CompaniesCom';
import AdminSidebar from 'admin/sidebar/AdminSidebar';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { CiSearch } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';

const Campanies = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [topCompaniesSideBardata, settopCompaniesSideBardata] = useState([]);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [promoFilter, setPromoFilter] = useState(''); 

  const storedData = localStorage.getItem('topcompanies');
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (storedData) {
      try {
        const topCustomerData = JSON.parse(storedData);
        settopCompaniesSideBardata(topCustomerData);
      } catch (error) {
        console.error("Invalid JSON format in localStorage:", error);
      }
    }

    const fetchData = async () => {
      const token = localStorage.getItem('accessTokenAdmin');
      const apiUrl = 'https://backend.washta.com/api/admin/JobHistory';

      try {
        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(response.data.data.reverse());
      } catch (err) {
        if (err.response && err.response.status === 401) {
          localStorage.clear();
          navigate('/');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const getCustomId = (item) => {
    if (!item?._id || !item?.date) return item?._id || "";
    const year = new Date(item.date).getFullYear();
    const lastSix = item._id.slice(-6).toUpperCase();
    return `WAS-${year}-${lastSix}`;
  };
  const filteredData = data?.filter((item) => {
    if (item.billingStatus === "non-paid") return false;

    const customId = getCustomId(item).toLowerCase();
    const shopName = item.shopId?.shopName?.toLowerCase() || "";
    const lowerSearch = searchQuery.toLowerCase();
    const matchesSearch = shopName.includes(lowerSearch) || customId.includes(lowerSearch);
    const matchesStatus = statusFilter === "" || item.status === statusFilter;
    let matchesDate = true;
    if (dateFilter) {
      const itemDateOnly = item.date?.split('T')[0];
      matchesDate = itemDateOnly === dateFilter;
    }
    let matchesPromo = true;
    if (promoFilter === "applied") {
      matchesPromo = item.promoCode !== null && item.promoCode !== "" && item.promoCode !== undefined;
    } else if (promoFilter === "not-applied") {
      matchesPromo = item.promoCode === null || item.promoCode === "";
    }

    return matchesSearch && matchesStatus && matchesDate && matchesPromo;
  });

  return (
    <div className='mainDiv-all-sideBar'>
      <div className='div-sidebar'>
        <AdminSidebar />
      </div>
      <div className='div-Dashbaord'>
        <h1 className='h1-all-heading'>Shops Booking</h1>
        <div className="dashboard">

          <div className='styles-div'>
            <div className="chart-container">
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <div className='input-feild-dic-icon' style={{ flex: 1, margin: 0, position: 'relative',  }}>
                  <CiSearch className='icon-serach-box-input' style={{ position: 'absolute', left: '10px', top: '18%' }} />
                  <input
                    placeholder='Search Shop Name or ID'
                    className='input-feild-class-job-history'
                    style={{ paddingLeft: '35px', width: '100%' }}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <select 
                  value={promoFilter}
                  onChange={(e) => setPromoFilter(e.target.value)}
                  className='invoice-search-icon-div'
              style={{ width: '130px', cursor: 'pointer' }}
                >
                  <option value="">All Promos</option>
                  <option value="applied">With Promo</option>
                  <option value="not-applied">No Promo</option>
                </select>

                {/* Status Dropdown */}
                <select 
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className='invoice-search-icon-div'
              style={{ width: '130px', cursor: 'pointer' }}
                >
                  <option value="">All Status</option>
                  <option value="ongoing">Ongoing</option>
                  <option value="completed">Completed</option>
                  <option value="pending">Pending</option>
                </select>

                {/* Small Date Input */}
                <input 
                  type="date"
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                 className='invoice-search-icon-div'
  style={{ 
    width: '140px', 
    borderRadius: '15px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#666',
    border: '1px solid #e0e0e0',
    padding: '5px 10px',
    backgroundColor: '#fdfdfd',
    transition: 'all 0.3s ease',
    outline: 'none'
  }}
                />
               
              </div>

              <div className="responsive-container" style={
    !loading && filteredData.length === 0
      ? { gridTemplateColumns: "none" }
      : {}
  }>
                {loading ? (
                  Array.from(new Array(6)).map((_, index) => (
                    <div key={index} className="responsive-item">
                      <div className="customer-card-skeleton" style={{ padding: '15px', background: '#fff', borderRadius: '10px' }}>
                        <Skeleton variant="rectangular" height={80} style={{ borderRadius: '10px' }} />
                      </div>
                    </div>
                  ))
                ) : filteredData.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px',width:"100%",display:"flex",justifyContent:"center",alignItems:"center" }}>
                    <p style={{ color: 'black' }}>No bookings found for the selected filters.</p>
                  </div>
                ) : (
                  filteredData.map((item) => (
                    <div key={item._id} className="responsive-item">
                      <CompaniesCom
                        item={item}
                        vist={formatDate(item?.date) + " At " + formatTimeInTimezone(item?.date)}
                        Loc={item.location?.text || "N/A"}
                        Service={item.serviceFee?.[0]?.serviceName || "Washta Service"}
                        ImagePro={item.shopId?.coverImage}
                        paymnet={item.cost}
                        textpopupBtn="Share details"
                        status={item.status}
                        orderTime={formatTimeInTimezone(item?.date)}
                        orderDate={formatDate(item?.date)}
                        orderId={getCustomId(item)} // Professional ID pass kiya hai
                        car={item.vehicleId?.vehicleName || "Car"}
                        buyerName={item.shopId?.shopName} 
                        show={true} 
                        Completed={item.status} 
                        name={item.shopId?.shopName} 
                        spent={item.cost} 
                      />
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          <div className='styles-div-text'>
            <TopCampanies data={topCompaniesSideBardata} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Campanies;